import { persist } from "zustand/middleware";
import { create } from "zustand/react";

type BannerStoreStateType = {
  isHidden: boolean;
};

type BannerStoreActionsType = {
  setHidden: (hidden: boolean) => void;
};

export const useBannerStore = create<
  BannerStoreStateType & BannerStoreActionsType
>()(
  persist(
    set => ({
      isHidden: false,
      setHidden: (hidden: boolean) =>
        set(state => ({ ...state, isHidden: hidden })),
    }),
    { name: "bannerStore" },
  ),
);
